import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { TemplateTwoPDFSection, TemplateTwoPDFSectionWithSubsections } from "./common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeLanguage } from "lib/redux/types";

export const Language = ({
  heading,
  languages,
  themeColor,
  enableMistakeHighlight = false,
}: {
  heading: string;
  languages: ResumeLanguage[];
  themeColor: string;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateTwoPDFSectionWithSubsections themeColor={themeColor} heading={heading}>
      {languages.map(({ language, level, descriptions }, idx) => (
        <View key={idx} wrap={false} style={{ ...styles.flexRow }}>
          <View style={{ width: "30%", marginTop: "2pt" }}></View> {/* Reduced from spacing["0.5"] (6pt) to 2pt */}
          <View style={{ width: "70%", marginTop: "2pt" }}> {/* Reduced from spacing["0.5"] (6pt) to 2pt */}
            <View
              style={{
                marginTop: spacing["0.5"],
              }}
            >
              <View
                style={{
                  ...styles.flexRow,
                  gap: spacing["2"],
                }}
              >
                <ResumePDFText bold={true}>{language}</ResumePDFText>
                <ResumePDFText>{level}</ResumePDFText>
              </View>
            </View>
            <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
              <ResumePDFDescription 
                items={descriptions} 
                enableMistakeHighlight={enableMistakeHighlight}
                section="languages"
                itemIndex={idx}
              />
            </View>
          </View>
        </View>
      ))}
    </TemplateTwoPDFSectionWithSubsections>
  );
};
